export const types = {
  Teoric: 1,
  Activity: 2,
  Additional: 3,
  Supplementary: 4,
  Project: 5
}
export function listTypes () {
  const data = [
    { name: 'Teórico', id: 1 },
    { name: 'Atividade', id: 2 },
    { name: 'Complementar', id: 3 },
    { name: 'Paradidático', id: 4 },
    { name: 'Projeto', id: 5 }
  ]
  return data
}
export const displayNames = {
  [types.Teoric]: 'Teórico',
  [types.Activity]: 'Atividade',
  [types.Additional]: 'Complementar',
  [types.Supplementary]: 'Paradidático',
  [types.Project]: 'Projeto'
}

export function getTextForDisplay (type) {
  const name = displayNames[type]

  if (name === undefined) {
    return ''
  }

  return name
}

export default {
  types,
  listTypes,
  displayNames,
  getTextForDisplay
}
